import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import Header from '../Header';


const useStyles = makeStyles(() => ({
  container: {
    marginBottom: 10
  },
}))

function BaseGameEvent({ children, team, time, type, period }) {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Header time={time} period={period} team={team} type={type} />
      <Grid container item xs={12}>
        {children}
      </Grid>
    </Grid>
  )
}

export default BaseGameEvent;
